import angular from 'angular';
import customDropdown from './customDropdown';
import './style.scss';

export default angular
  .module('components.customDropdown', [])
  .component('customDropdown', customDropdown).name;
